import { _ as r } from "../internals/export.js";
import { g as s } from "../internals/global.js";
import { a } from "../internals/array-buffer.js";
import { s as o } from "../internals/set-species.js";
var e = "ArrayBuffer",
  t = a[e];
r({
  global: !0,
  constructor: !0,
  forced: s[e] !== t
}, {
  ArrayBuffer: t
}), o(e);